import { useContext } from 'react'

import { AbilityContext } from '~/layouts/components/acl/Can'

export default function useIsAdmin() {
  const ability = useContext(AbilityContext)
  return ability.can('manage', 'admin')
}
